import Vuex from 'vuex'

export default new Vuex.Store({
	state: {
		rates: [],
        rateHistory: [],
		groups: {},
        loadingRates: true,
        loadingMarketGroups: true,
        updatedRates: {},
        ratesEditMode: {},
    },
    getters: {
        types(state) {
            return {
                'HELOC': 'HELOC',
                'Home-Equity-Loan': 'Home Equity Loan',
                'Home-Co-Investing': 'Home Co-Investing',
                'Cashout-Refinance': 'Cash Out Refinance'
            };
        },
        getTypes(state) {
            return {
                HELOC: 'HELOC',
                HomeEquityLoan: 'Home-Equity-Loan',
                HomeCoInvesting: 'Home-Co-Investing',
                CashoutRefinance: 'Cashout-Refinance'
            };
        },

        rates(state) {
            return state.rates;
        },
        rateHistory(state) {
            return state.rateHistory;
        },
        ratesEditMode(state) {
            return state.ratesEditMode;
        },
		groups(state) {
			return state.groups;
		},
        loadingRates(state) {
            return state.loadingRates;
        },
        updatedRates(state) {
            return state.updatedRates;
        }
	},
	actions: {
		fetchRates(context) {
            context.commit('isLoadingRates');
            axios.get('/api/home-equity/rates')
                .then((response) => {
                    let ratesEditMode = {};
                    for(let i = 0, l = response.data.rates.length; i < l; i++) {
                        let rate = response.data.rates[i];
                        ratesEditMode[rate.id] = false;
                    }
                    context.commit('setRatesEditMode', ratesEditMode);
                    context.commit('setRates', response.data.rates);
                    context.commit('notLoadingRates');
                })
                .catch(() => {
                    context.commit('notLoadingRates');
                });
        },
        fetchMarketGroups(context) {
            context.commit('isLoadingMarketGroups');
            axios.get('/api/home-equity/market-groups')
                .then((response) => {
                    context.commit('setGroups', response.data.groups);
                    context.commit('notLoadingMarketGroups');
                })
                .catch(() => {
                    context.commit('notLoadingMarketGroups');
                });
        },
        handleRateUpdates(context, updatedRates) {
            let rates = context.state.rates;
            let ratesEditMode = context.state.ratesEditMode;
            for(let i = 0, l = updatedRates.length; i < l; i++) {
                let updatedRate = updatedRates[i];
                let found = false;
                rates = rates.map(r => {
                    if (r.id == updatedRate.id) {
                        found = true;
                        return updatedRate;
                    }
                    return r;
                });
                if (!found) {
                    ratesEditMode[updatedRate.id] = false;
                    rates.push(updatedRate);
                }
                context.commit('addUpdatedRate', updatedRate.id);
            }
            context.commit('setRates', rates);
            context.commit('setRatesEditMode', ratesEditMode);
        },
        beginEditMode(context, rateId) {
            let ratesEditMode = context.state.ratesEditMode;
            if (typeof ratesEditMode[rateId] !== 'undefined') {
                ratesEditMode[rateId] = true;
            }
            context.commit('setRatesEditMode', ratesEditMode);
        },
        endEditMode(context, rateId) {
            let ratesEditMode = context.state.ratesEditMode;
            if (typeof ratesEditMode[rateId] !== 'undefined') {
                ratesEditMode[rateId] = false;
            }
            context.commit('setRatesEditMode', ratesEditMode);
        },
        beginEditModeAll(context) {
            let ratesEditMode = context.state.ratesEditMode;
            let rates = context.state.rates;
            for(let i = 0, l = rates.length; i < l; i++) {
                ratesEditMode[rates[i].id] = true;
            }
            context.commit('setRatesEditMode', ratesEditMode);
        }
	},
	mutations: {
		isLoadingRates(state) {
            state.loadingRates = true;
        },
        notLoadingRates(state) {
            state.loadingRates = false;
        },
        isLoadingMarketGroups(state) {
            state.loadingMarketGroups = true;
        },
        notLoadingMarketGroups(state) {
            state.loadingMarketGroups = false;
        },
		setRates(state, payload) {
			state.rates = payload;
        },
		setRateHistoryDetails(state, payload) {
			state.rateHistory = payload;
        },
        setRatesEditMode(state, payload) {
            state.ratesEditMode = payload;
        },
		setGroups(state, payload) {
			state.groups = payload;
        },
        addUpdatedRate(state, payload) {
            state.updatedRates[payload] = true;
        }
	}
});
